export const GooglePlayIcon = ({ className = "h-6 w-6" }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M3.6 2.3c-.34.36-.53.9-.53 1.56v16.28c0 .66.2 1.2.53 1.56l.08.07 9.12-9.12v-.22L3.68 2.23l-.08.07zm11.6 9.04-2.44-2.44 3.35-3.35 4.02 2.28c1.15.65 1.15 1.72 0 2.38l-4.02 2.28-3.35-3.35 2.44 2.44v.22zm-.65.65-2.79-2.79-9.24 9.24c.38.4 1.02.45 1.74.05l9.29-5.26-2.79 2.79 2.79-2.79-2.79 2.79zm0-4.72L5.26 2.01c-.72-.4-1.36-.35-1.74.05l9.24 9.24 2.79-2.79-1 1-1.79-1.79z" />
  </svg>
);

export const AppleIcon = ({ className = "h-6 w-6" }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8.98-.2 1.92-.86 3.24-.77 1.58.13 2.77.75 3.55 1.9-3.27 1.96-2.5 6.27.49 7.55-.6 1.58-1.38 3.15-2.36 3.49zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z" />
  </svg>
);

export const TikTokIcon = ({ className = "h-5 w-5" }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
  </svg>
);
